// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3525":"6d0a3394461a75d5","4034":"e392895eee7880a0","6009":"f81f0ed806d91028","9073":"b040afa6ad2625fb"}[chunkId] + ".css";
};